import api from '@/lib/axios';

export const ventasService = {
  async create(data: {
    companyId: string;
    branchId: string;
    userId?: string;
    cashRegisterId?: string;
    customerId?: string;
    items: Array<{ productId: string; quantity: number; unitPrice: number; discount?: number }>;
    payments: Array<{ method: string; amount: number; reference?: string; cardType?: string; cardLast4?: string }>;
    subtotal: number;
    discountTotal?: number;
    taxTotal?: number;
    grandTotal: number;
    paidAmount: number;
    changeAmount?: number;
    notes?: string;
    registerPrefix?: string;
    status?: 'PENDING_PAYMENT' | 'COMPLETED' | 'QUOTATION';
  }) {
    const response = await api.post('/sales', data);
    return response.data;
  },

  async findAll(params: {
    companyId: string;
    branchId?: string;
    customerId?: string;
    status?: string;
    search?: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
  }) {
    const response = await api.get('/sales', { params });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/sales/${id}`);
    return response.data;
  },

  async pay(id: string, data: {
    payments: Array<{ method: string; amount: number; reference?: string; cardType?: string; cardLast4?: string }>;
    cashRegisterId?: string;
    paidAmount: number;
    changeAmount?: number;
  }) {
    const response = await api.patch(`/sales/${id}/pay`, data);
    return response.data;
  },

  async cancel(id: string, data: { cancelledById?: string; reason: string }, adminToken?: string) {
    const config = adminToken ? { headers: { Authorization: `Bearer ${adminToken}` } } : {};
    const { cancelledById, ...body } = data;
    const response = await api.patch(`/sales/${id}/cancel`, body, config);
    return response.data;
  },

  async returnItems(id: string, data: { items: Array<{ productId: string; quantity: number }>; reason: string }) {
    const response = await api.post(`/sales/${id}/return`, data);
    return response.data;
  },
};
